
import React, { ReactNode, useState, useEffect } from 'react';
import axios from 'axios';
// @ts-ignore: allow importing CSS without a type declaration
import '../Tracking/PacifixTracking.css';
// import Logo from '../Logo/Jaimarutilogo.png';
import ShreRamji from '../Logo/Aslogisticslogo.png';
import Swal from "sweetalert2";
<link rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css"></link>


interface StatusEntry {
    Destination_name: string;
    LocationName: string;
    Status: string;
    DelvDt: string;
    DelvTime: string;
}

interface TrackingRecord {
    DocketNo: string;
    BookDate: string;
    DelvDT: string;
    ExptDateOfDelvDt: string;
    OriginCity: string;
    DestinationCity: string;
    Consignee_Name: string;
    Status: string;
    DelvTime: string | null;
    VendorAwbNo: string;
    Vendor_Name: string;
    ActualWt: number;
    ChargedWt: number;
    Qty: number;

    EwayBill: string;
    InvoiceNo: string;

    Mode_Code: string;

    Consignee_Mob: string;
    Consignee_Pin: string;

    RecvName: string | null;
    ReceivedMo: string;
    Recvremark: string | null;

    DrsDate: string | null;
    DrsNo: string | null;

    Employee_code: string | null;
    Employee_Mobile: string | null;

    Area: string | null;
    VehicleNo: string | null;

    Location_Code: string | null;

    Manifest_No: string | null;
    Manifest_Dt: string | null;

    From_Dest: string | null;
    ManifestDestination: string | null;
    ImageLink?: string;
    StatusEntry: StatusEntry[];
}

const AsTracking = (): JSX.Element => {
    const [searchValue, setSearchValue] = useState('');
    const [trackingData, setTrackingData] = useState<TrackingRecord | null>(null);
    const [skyNetData, setSkyNetData] = useState<any>(null);
    const [showPod, setShowPod] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState('');


    const handleButtonClick = () => {
        setShowPod(!showPod);
    };



    useEffect(() => {

        const toggleButton = document.getElementById("toggleButton");
        const buttonContainer = document.getElementById("buttonContainer");
        const whatsappMobileButton = document.getElementById("whatsappMobile");
        const whatsappWebButton = document.getElementById("whatsappWeb");
        const callButton = document.querySelector(".callbackfuncation");





        if (!toggleButton) return;

        toggleButton.addEventListener("click", function () {
            buttonContainer?.classList.toggle("hidden");
        });

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            if (whatsappWebButton)
                (whatsappWebButton as HTMLElement).style.display = "none";
        } else {
            if (whatsappMobileButton)
                (whatsappMobileButton as HTMLElement).style.display = "none";
        }

        whatsappMobileButton?.addEventListener("click", function (event) {
            event.preventDefault();
            window.open("https://wa.me/917011209462", "_blank");
        });

        whatsappWebButton?.addEventListener("click", function (event) {
            event.preventDefault();
            window.open(
                "https://web.whatsapp.com/send?phone=917011209462&text=Hello%20there!",
                "_blank"
            );
        });

        callButton?.addEventListener("click", function (event) {
            event.preventDefault();
            window.location.href = "tel:+91 9888100259";
        });

    }, []);
    // 👆 YAHAN TAK PASTE KARO




    const fetchSkyNetData = async (awb: string) => {
        try {

            const res = await axios.get(
                `https://erp.futureinfosys.in/Aslogistics/Master/SkyNetTracking?awb=${awb}`
            );

            console.log("SkyNet =", res.data);

            if (
                res.data.status === 1 &&
                res.data.Data.stateCode === "SUCCESS"
            ) {
                setSkyNetData(res.data.Data.data);
            }

        } catch (err) {
            console.log(err);
        }
    };


    const getTrackingUrl = (
        awb: string,
        vendor?: string,
        pin?: string
    ) => {

        if (!awb) return "#";

        const v = (vendor || "")
            .toUpperCase()
            .trim()
            .replace(/\s+/g, " ");

        console.log("Vendor =", v);
        console.log("AWB =", awb);

        // ================= INTERNATIONAL =================

        if (v.includes("DHL")) {
            return `https://www.dhl.com/in-en/home/tracking.html?tracking-id=${awb}&submit=1`;
        }

        if (v.includes("DPD")) {
            return `https://track.dpd.co.uk/?reference=${awb}`;
        }

        if (v.includes("PUROLATOR")) {
            return `https://www.purolator.com/en/shipping/tracker?pin=${awb}`;
        }

        if (v.includes("FEDEX")) {
            return `https://www.fedex.com/fedextrack/?trknbr=${awb}`;
        }

        if (v.includes("UPS")) {
            return `https://www.ups.com/track?tracknum=${awb}`;
        }

        if (v.includes("SKYNET")) {
            return "https://www.skynetww.com/track";
        }

        if (v.includes("ARAMEX")) {
            return `https://www.aramex.com/track/results?ShipmentNumber=${awb}`;
        }

        if (v.includes("COURIERSPLEASE") || v.includes("COURIERS PLEASE")) {
            return `https://www.couriersplease.com.au/tools-track?no=${awb}`;
        }

        if (v.includes("USPS")) {
            return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${awb}`;
        }

        if (v.includes("CANADA POST")) {
            return `https://www.canadapost-postescanada.ca/track-reperage/en#/search?searchFor=${awb}`;
        }

        if (v.includes("ROYAL MAIL")) {
            return `https://www.royalmail.com/track-your-item#/tracking-results/${awb}`;
        }

        if (v.includes("TNT")) {
            return `https://www.tnt.com/express/en_in/site/shipping-tools/tracking.html`;
        }

        // ================= INDIA =================

        // if (v.includes("SKYNET")) {
        //     return `https://skynetww.com/track/${awb}`;
        // }

        if (v.includes("SKYNET")) {
            return "https://www.skynetww.com/track";
        }

        if (v.includes("DTDC")) {
            return `https://www.dtdc.in/tracking/tracking_results.asp?strCnno=${awb}`;
        }

        if (v.includes("BLUE DART") || v.includes("BLUEDART")) {
            return `https://www.bluedart.com/tracking?tracking_number=${awb}`;
        }

        if (v.includes("DELHIVERY")) {
            return `https://www.delhivery.com/track/package/${awb}`;
        }

        if (v.includes("XPRESSBEES")) {
            return `https://www.xpressbees.com/shipment-tracking?awb=${awb}`;
        }

        if (v.includes("ECOM")) {
            return `https://ecomexpress.in/tracking/?awb_field=${awb}`;
        }

        if (v.includes("EKART")) {
            return `https://ekartlogistics.com/shipmenttrack/${awb}`;
        }

        if (v.includes("SHADOWFAX")) {
            return `https://www.shadowfax.in/`;
        }

        if (v.includes("GATI")) {
            return `https://www.gati.com/tracking`;
        }

        if (v.includes("TCI")) {
            return `https://www.tciexpress.in/trackingdocket.aspx`;
        }

        if (v.includes("TRACKON")) {
            return `https://trackon.in/Tracking.aspx`;
        }

        if (v.includes("PROFESSIONAL")) {
            return `https://www.tpcindia.com/Tracking.aspx`;
        }

        if (v.includes("SAFEXPRESS")) {
            return `https://www.safexpress.com/track-shipment`;
        }

        if (v.includes("FIRST FLIGHT")) {
            return `https://www.firstflight.net/track`;
        }

        if (v.includes("INDIA POST") || v.includes("SPEED POST")) {
            return `https://www.indiapost.gov.in/_layouts/15/dop.portal.tracking/trackconsignment.aspx`;
        }

        if (v.includes("OVERNITE")) {
            return `https://www.overnitenet.com/Tracking.aspx`;
        }

        if (v.includes("SHREE MARUTI")) {
            return `https://www.shreemaruti.com/track-your-shipment`;
        }

        if (v.includes("MADHUR")) {
            return `https://www.madhurcouriers.in/track`;
        }

        if (v.includes("MARUTI")) {
            return `https://www.maruticourier.com/track-your-shipment`;
        }

        return "#";
    };





    const fetchData = async () => {
        try {
            if (!searchValue.trim()) {
                Swal.fire({
                    icon: "warning",
                    title: "Enter Docket Number",
                    text: "📩 Please enter Docket No to get tracking details",
                });
                return;
            }

            // ✅ New API URL
            const url = `https://erp.futureinfosys.in/Aslogistics/Master/getTrackingData?DocketNo=${searchValue}`;

            const res = await axios.get(url);

            // ✅ API Response Check
            if (res.data.status === 1 && res.data.Data.length > 0) {

                // First tracking object
                const tracking = res.data.Data[0];

                setTrackingData(tracking);

                // ✅ Call SkyNet API automatically
                if (
                    tracking.Vendor_Name &&
                    tracking.Vendor_Name.toUpperCase().includes("SKYNET")
                ) {
                    await fetchSkyNetData(tracking.VendorAwbNo);
                }

                setSearchValue("");

                Swal.fire({
                    icon: "success",
                    title: "Tracking Found",
                    timer: 1200,
                    showConfirmButton: false,
                });

            } else {
                Swal.fire({
                    icon: "error",
                    title: "No Data Found",
                });
            }

        } catch (error) {
            console.log(error);

            Swal.fire({
                icon: "error",
                title: "Error fetching data",
                text: "Unable to fetch tracking details",
            });
        }
    };


    const downloadPod = async () => {

        if (!trackingData?.ImageLink) return;

        try {

            const response = await fetch(trackingData.ImageLink);

            if (!response.ok) {
                throw new Error("Image not found");
            }

            const blob = await response.blob();

            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");

            link.href = blobUrl;

            const fileName =
                trackingData.ImageLink.split("/").pop() ||
                `POD_${trackingData.DocketNo}.png`;

            link.download = fileName;

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl);

        } catch (err) {

            console.error(err);

            Swal.fire({
                icon: "error",
                title: "Download Failed",
                text: "Unable to download POD Image.",
            });

        }

    };

    return (

        <>

            <header className="navbarheader-fluid">

                {/* TOP BAR */}
                <div className="top-bar">
                    Welcome to AS LOGISTICS EXPRESS | +91 7011209462 - 8383872690  - info@aslogisticsexpress.com
                </div>

                {/* DESKTOP NAVBAR */}
                <div className="navbar-container d-none d-lg-flex">

                    <div className="navbar-logo">
                        <img
                            src={ShreRamji}
                            alt="logo"
                            style={{
                                width: "100px",
                                height: "auto",
                                objectFit: "contain"
                            }}
                        />
                    </div>

                    <nav className="navbar-links">
                        <a href="http://aslogisticsexpress.com/">Home</a>
                        <a href="http://aslogisticsexpress.com/Abouts.html">About Us</a>
                        <a href="http://aslogisticsexpress.com/ourservice.html">Services</a>
                        <a href="http://aslogisticsexpress.com/NewLogin/#/login">Branch Login</a>
                        <a href="http://aslogisticsexpress.com/Document.html">Document</a>
                        <a href="http://aslogisticsexpress.com/Contactus.html">Contact</a>
                    </nav>

                </div>

                {/* MOBILE NAVBAR */}
                <nav className="navbar bg-light fixed-top d-lg-none">
                    <div className="container-fluid">

                        {/* MENU BUTTON */}
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        {/* LOGO */}
                        <a className="navbar-brand ms-auto" href="#">
                            <img src={ShreRamji} alt="logo" />
                        </a>

                        {/* SIDEBAR MENU */}
                        <div className="offcanvas offcanvas-start" id="offcanvasNavbar">
                            <div className="offcanvas-header">
                                <h5>Menu</h5>
                                <button className="btn-close" data-bs-dismiss="offcanvas"></button>
                            </div>

                            <div className="offcanvas-body">
                                <ul className="navbar-nav">

                                    <li><a href="http://aslogisticsexpress.com/index.html">Home</a></li>
                                    <li><a href="http://aslogisticsexpress.com/Abouts.html">About Us</a></li>
                                    <li><a href="http://aslogisticsexpress.com/ourservice.html">Services</a></li>
                                    <li><a href="http://aslogisticsexpress.com/NewLogin/#/login">Branch Login</a></li>
                                    <li><a href="http://aslogisticsexpress.com/Document.html">Document</a></li>
                                    <li><a href="http://aslogisticsexpress.com/Contactus.html">Contact</a></li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </nav>

            </header>
            <div className="tracking-container">


                <div className="tracking-wrapper">

                    <h2 className="title">
                        Track Shipment 🚚
                    </h2>

                    <div className="track-form">

                        <input
                            type="text"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            placeholder="Enter AWB Number"
                            style={{
                                width: "300px",
                                height: "60px",
                                fontSize: "20px",
                                padding: "0 20px",
                                borderRadius: "10px",
                                border: "2px solid #ccc",
                            }}
                        />

                        <button className="track-btn" onClick={fetchData}>
                            Track
                        </button>

                    </div>

                    {/* Floating Contact Buttons */}

                    <div className="floating-contact">

                        <div id="buttonContainer" className="hidden">

                            {/* Call */}

                            <a
                                href="tel:+917011209462"
                                className="callbackfuncation"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <i className="fas fa-phone-alt"></i>
                            </a>

                            {/* WhatsApp Mobile */}

                            <a
                                href="https://wa.me/917011209462"
                                className="btn-whatsapp-pulse whatsapp"
                                id="whatsappMobile"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fab fa-whatsapp"></i>
                            </a>

                            {/* WhatsApp Web */}

                            <a
                                href="https://web.whatsapp.com/send?phone=917011209462&text=Hello%20there!"
                                className="btn-whatsapp-pulse whatsapp"
                                id="whatsappWeb"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fab fa-whatsapp"></i>
                            </a>

                        </div>

                        <button id="toggleButton" className="animated-button">
                            <i className="fas fa-comments"></i>
                        </button>

                    </div>

                </div>


                {error && <p className="error">{error}</p>}

                {trackingData && (
                    <div className="result-section">

                        <div className="grid">

                            {/* LEFT */}
                            <div className="card">
                                <div className="card-header">Shipment Details</div>

                                <table className="shipment-table">
                                    <tbody>

                                        <tr>
                                            <td className="label">Docket No.</td>
                                            <td>{trackingData?.DocketNo}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Booking Date</td>
                                            <td>{trackingData?.BookDate}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Consignee</td>
                                            <td>{trackingData?.Consignee_Name}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Origin</td>
                                            <td>{trackingData?.OriginCity}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Destination</td>
                                            <td>{trackingData?.DestinationCity}</td>
                                        </tr>

                                        {<tr>
                                            <td className="label">Vendor AWB</td>
                                            <td>{trackingData?.VendorAwbNo}</td>
                                        </tr>}

                                        <tr>
                                            <td className="label">Vendor</td>
                                            <td>
                                                <strong>{trackingData?.Vendor_Name || "N/A"}</strong>
                                                <br />

                                                {trackingData?.VendorAwbNo ? (
                                                    <a
                                                        href={getTrackingUrl(
                                                            trackingData?.VendorAwbNo,
                                                            trackingData?.Vendor_Name,
                                                            trackingData?.Consignee_Pin
                                                        )}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {trackingData?.VendorAwbNo}
                                                    </a>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="label">Status</td>
                                            <td>{trackingData?.Status}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Weight</td>
                                            <td>{trackingData?.ActualWt} KG</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Qty</td>
                                            <td>{trackingData?.Qty}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">ReceiverName</td>
                                            <td>{trackingData?.RecvName}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">ReceivedMo</td>
                                            <td>{trackingData?.ReceivedMo}</td>
                                        </tr>
                                        <tr>
                                            <td className="label">POD Image</td>
                                            <td>
                                                {trackingData?.ImageLink ? (
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        onClick={() => setShowPod(true)}
                                                    >
                                                        View POD
                                                    </button>
                                                ) : (
                                                    <span>No POD Available</span>
                                                )}
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>

                            </div>

                            {/* RIGHT */}
                            <div className="card">
                                <div className="card-header">Shipping History</div>

                                <table>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>Location</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        {trackingData?.StatusEntry?.length > 0 ? (
                                            trackingData.StatusEntry.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{item.DelvDt}</td>
                                                    <td>{item.DelvTime}</td>
                                                    <td>{item.Destination_name}</td>
                                                    <td>{item.Status}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={4}>No Tracking History</td>
                                            </tr>
                                        )}

                                    </tbody>

                                </table>
                                {skyNetData?.shipmentHistory?.length > 0 && (

                                    <div className="card mt-4">

                                        <div className="card-header">
                                            🌍 SkyNet Shipment History
                                        </div>

                                        <table className="table table-bordered">

                                            <thead>

                                                <tr>

                                                    <th>Date</th>
                                                    <th>Time</th>
                                                    <th>Status</th>
                                                    <th>Details</th>
                                                    <th>Location</th>

                                                </tr>

                                            </thead>

                                            <tbody>

                                                {skyNetData.shipmentHistory.map((item: any, index: number) => (

                                                    <tr key={index}>

                                                        <td>{item.date}</td>

                                                        <td>{item.time}</td>

                                                        <td>

                                                            <span className="badge bg-primary">

                                                                {item.shipmentStatus}

                                                            </span>

                                                        </td>

                                                        <td>{item.shipmentDetails}</td>

                                                        <td>{item.location}</td>

                                                    </tr>

                                                ))}

                                            </tbody>

                                        </table>

                                    </div>

                                )}

                            </div>

                        </div>
                    </div>
                )}

                {/* FOOTER */}
                <footer className="footer-light">
                    <div className="footer-container-fluid">

                        <div className="footer-grid">

                            {/* COLUMN 1 */}
                            <div className="footer-box">
                                <h3>As Logistics Express</h3>

                                <h4>New Delhi (Head Office)</h4>
                                <p>
                                    As a privately owned company, we are a highly focused and capable logistics specialist with a strong global presence and extensive agency representation across most countries. At <br /> <b>As Logistics Express</b> WORLD WIDE LOGISTICS, client satisfaction is our top priority. We are committed to delivering reliable, efficient, and tailored solutions every time.
                                </p>
                            </div>

                            {/* COLUMN 2 */}
                            <div className="footer-box">
                                <h3>As Logistics Express</h3>

                                <h4>New Delhi (Office)</h4>
                                <p>
                                    A-66,Green Farm Road No. 4, Room No. 102, Street No. 7,
                                    Mahipalpur, New Delhi – 110037
                                </p>
                                <p>📞 +91  7011209462 </p>
                                <p>📞 +91  8383872690 </p>

                                <p>✉ info@aslogisticsexpress.com</p>
                            </div>

                            {/* COLUMN 3 */}
                            <div className="footer-box">
                                <h3>SERVICES</h3>
                                <ul className="services-list">
                                    <li>Air Ticket Booking</li>
                                    <li>Tour Packages</li>
                                    <li>Tourist Visa Assistance</li>
                                    <li>Money Transfer Services</li>
                                    <li>Airline Consolidation</li>
                                    <li>Port to Port Shipping</li>
                                    <li>Air Cargo</li>
                                    <li>Sea Freight Cargo</li>
                                    <li>Packers and Movers </li>
                                </ul>
                            </div>

                            {/* ✅ NEW COLUMN 4 */}
                            <div className="footer-box">
                                <h3>QUICK LINKS</h3>
                                <ul className="services-list">
                                    <li>Home</li>
                                    <li>About Us</li>
                                    <li>Tracking</li>
                                    <li>Contact</li>
                                    <li>Privacy Policy</li>
                                    <li>Standard Conditions of Carriage</li>
                                    <li>Payment Terms and Conditions</li>
                                    <li>Food Items</li>


                                </ul>
                            </div>

                        </div>

                    </div>
                </footer>
                <div className="footer-bottom">
                    <div className="footer-bottom-container">

                        <div className="footer-left">
                            © 2026 As Logistics Express Rights Reserved.
                        </div>

                        <div className="footer-right">
                            <a href="#">Privacy & Policy</a>
                            <a href="#">Terms & Conditions</a>

                            <a
                                href="https://www.futureinfosys.in/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="developer-credit"
                            >
                                Designed & Developed by Future Infosys Technologies
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </>





    );
};

export default AsTracking;